import clsx from 'clsx';
import React, { useContext, useRef } from 'react';
import { Element } from '../../element';
import { Icon } from '../../icon';
import AccordionContext from '../context/context';
import * as styles from '../accordion.styles';

/**
 *
 * @type {typeof import('..').AccordionHeader}
 */
const Header = ({ className, children, ...props }) => {
  const { icon, name, onChange, expanded, ref } = useContext(AccordionContext);
  const tempRef = useRef();
  const checkRef = ref || tempRef;

  const handleHeaderOnClick = (evt) => {
    evt.stopPropagation();
  };

  return (
    <Element
      as="label"
      role="button"
      tabIndex={0}
      withEnterAsClick
      isInteractive
      className={clsx(styles.components.title, className, { [styles.variants.expanded]: expanded })}
      {...props}
    >
      <input
        name={name}
        onChange={onChange}
        type="checkbox"
        style={{ visibility: 'hidden', position: 'absolute' }}
        checked={expanded}
        ref={checkRef}
        onClick={handleHeaderOnClick}
      />
      <Element style={{ width: '100%' }} as="div">
        {children}
      </Element>
      <Icon name={icon ?? 'back'} className={clsx(styles.components.icon, { [styles.variants.expanded]: expanded })} />
    </Element>
  );
};

if (process.env.NODE_ENV !== 'production') {
  Header.displayName = 'Accordion.Header';
}

export default Header;
